class ProductServicesDetailsDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.handleTabKey = (event) => {
      if (event.key !== 'Tab' || !this.classList.contains('active')) return;
      const inner = this.querySelector('.product-services-details-drawer__inner');
      if (!inner) return;
      // 每次按 Tab 都重新获取，跳过隐藏、禁用和不可进入 Tab 序的控件。
      const elements = getFocusableElements(inner).filter(element =>
        element.tabIndex >= 0 && !element.matches(':disabled') &&
        !element.closest('[hidden], [inert], [aria-hidden="true"]') &&
        element.getClientRects().length && getComputedStyle(element).visibility === 'visible'
      );
      const first = elements[0];
      const last = elements[elements.length - 1];
      const current = document.activeElement;
      if (!elements.includes(current) ||
          (event.shiftKey && current === first) || (!event.shiftKey && current === last)) {
        event.preventDefault();
        (event.shiftKey ? last || inner : first || inner).focus({ preventScroll: true });
      }
    };
    
    // 使用事件委托处理遮罩层点击
    this.addEventListener('click', (evt) => {
      if (evt.target.id === 'ProductServicesDetailsDrawer-Overlay' || 
          evt.target.classList.contains('product-services-details-drawer__overlay')) {
        this.close();
      }
    });
  }

  open() {
    // 防止页面抖动：计算滚动条宽度并设置padding补偿
    this.preventLayoutShift();

    this.classList.add('active');
    document.addEventListener('keydown', this.handleTabKey, true);
    document.body.classList.add('product-services-details-drawer-open');
    // 等待显示样式生效后聚焦；若期间已关闭，则不再移动焦点。
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (!this.isConnected || !this.classList.contains('active')) return;
      this.querySelector('.product-services-details-drawer__close')?.focus({ preventScroll: true });
    }));
  }

  close(focusToggle = true) {
    this.classList.remove('active');
    document.removeEventListener('keydown', this.handleTabKey, true);
    document.body.classList.remove('product-services-details-drawer-open');

    // 恢复页面滚动
    document.body.classList.remove('overflow-hidden');
    const scrollbarWidth = document.documentElement.style.getPropertyValue('--scrollbar-width');
    if (scrollbarWidth) {
      document.body.style.paddingRight = '';
      document.documentElement.style.removeProperty('--scrollbar-width');
    }

    // 恢复焦点
    if (focusToggle && this.activeElement) {
      this.activeElement.focus();
    }
  }

  preventLayoutShift() {
    // 计算滚动条宽度
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    // 防止页面滚动
    document.body.classList.add('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleTabKey, true);
    document.body.classList.remove('product-services-details-drawer-open');
  }
}

customElements.define('product-services-details-drawer', ProductServicesDetailsDrawer);
